module.exports = __webpack_public_path__ + "img/averageNetSalaryForThisMonth.0d469b8a.png";